<p>
  {{ 'BS:PERSONAL_BROKER_TARIFF_INFO_1' | translate }} <a href="https://www.aigenis.ru/contactus" target="_blank">{{ 'BS:PERSONAL_BROKER_TARIFF_INFO_2' | translate }}</a>
  {{ 'BS:PERSONAL_BROKER_TARIFF_INFO_3' | translate }}
</p>
<div class="d-flex align-items-center justify-content-center">
  <button mat-button mat-dialog-close>{{ 'OK' | translate }}</button>
</div>
